import React, { Fragment } from 'react';
import { AlarmClockIcon, FlameIcon, UsersIcon } from 'lucide-react';
import { useSharedCountdown } from './CountdownTimer';
export function UrgencyModule() {
  const secondsLeft = useSharedCountdown();
  const TOTAL_SPOTS = 50;
  const spotsLeft = 4;
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const hours = 0;
  const percentLeft = spotsLeft / TOTAL_SPOTS * 100;
  return <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-900 via-red-950 to-black py-12 px-4 border-y-4 border-red-600 relative overflow-hidden shadow-[0_0_40px_rgba(220,38,38,0.2)]" data-id="element-523" data-mp="2hki4tss9ww22">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-600/10 rounded-full blur-3xl pointer-events-none" data-id="element-524" data-mp="27phr8o79unrv"></div>
      <div className="max-w-4xl mx-auto" data-id="element-525" data-mp="5wa2yp9okvtu">
        {/* Top alert badge */}
        <div className="flex justify-center mb-5" data-id="element-526" data-mp="av3e4b1hwaqu">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-xs md:text-sm px-4 py-2 rounded-full uppercase tracking-wider shadow-lg shadow-red-900/50 ring-2 ring-red-400/40" data-id="element-527" data-mp="ashaunln0hef">
            <FlameIcon className="h-4 w-4 animate-pulse" data-id="element-528" data-mp="1at0zdwkkq778" />
            ¡Atención! Oferta a punto de finalizar
          </div>
        </div>

        {/* Main headline */}
        <h2 className="mx-auto mb-3 max-w-4xl text-center text-3xl font-black uppercase leading-tight md:text-5xl" data-id="element-529" data-mp="15uppjlua3wp0">
          <span className="text-white" data-id="element-530" data-mp="i66itaqvnrz1">Aprovechá el</span>{' '}
          <span className="text-red-400 drop-shadow-[0_0_14px_rgba(239,68,68,0.7)]" data-id="element-531" data-mp="d6k38unktzn2">
            60% OFF
          </span>{' '}
          <span className="text-white" data-id="element-532" data-mp="r2x9f7mnuem8">antes de que termine</span>
        </h2>

        <p className="text-center text-red-100/80 text-sm md:text-base mb-8" data-id="element-533" data-mp="n1va6qsqu2k9">
          Esta promoción es exclusiva y limitada. Cuando el reloj llegue a cero
          o se agoten los cupos, vuelve al precio regular.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-2" data-id="element-534" data-mp="1ykxycn2xd4qx">
          {/* Countdown Card */}
          <div className="bg-gradient-to-br from-red-950 to-black rounded-2xl p-6 border-2 border-red-500/60 shadow-2xl shadow-red-900/40" data-id="element-535" data-mp="v9s90sp95rie">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-536" data-mp="155c0n2wsa41c">
              <AlarmClockIcon className="h-5 w-5 text-red-400" data-id="element-537" data-mp="197gthzfeqwmx" />
              <p className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-538" data-mp="196nwvra5xnii">
                La oferta expira en
              </p>
            </div>
            <div className="flex justify-center gap-2 md:gap-3" data-id="element-539" data-mp="hfrg4fkzeypy">
              {[{
              value: hours,
              label: 'Horas'
            }, {
              value: minutes,
              label: 'Minutos'
            }, {
              value: seconds,
              label: 'Segundos'
            }].map((unit, i) => <Fragment key={unit.label} data-id="element-540" data-mp="3pv1jrs4isbzu" data-mpi={i}>
                  <div className="flex flex-col items-center" data-id="element-541" data-mp="3pu9wd4l2tkkn">
                    <div className="bg-black border-2 border-red-600/70 rounded-lg px-3 md:px-5 py-2 md:py-3 shadow-[0_0_15px_rgba(239,68,68,0.3)] min-w-[60px] md:min-w-[80px]" data-id="element-542" data-mp="3twd8lvfkkt6z">
                      <span className="text-3xl md:text-5xl font-black text-red-400 tabular-nums tracking-tight drop-shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-543" data-mp="3heu57ux2rzxw">
                        {String(unit.value).padStart(2, '0')}
                      </span>
                    </div>
                    <span className="text-[10px] md:text-xs text-red-200/70 mt-2 uppercase tracking-wider font-semibold" data-id="element-544" data-mp="33f15ja3km9ds">
                      {unit.label}
                    </span>
                  </div>
                  {i < 2 && <span className="text-3xl md:text-5xl font-black text-red-500 self-start mt-1 md:mt-2" data-id="element-545" data-mp="2tozq16pa9zah">
                      :
                    </span>}
                </Fragment>)}
            </div>
          </div>

          {/* Spots Card */}
          <div className="bg-gradient-to-br from-red-950 to-black rounded-2xl p-6 border-2 border-red-500/60 shadow-2xl shadow-red-900/40" data-id="element-546" data-mp="2ko1lmnaxnprd">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-547" data-mp="jmu2b38icuh6">
              <UsersIcon className="h-5 w-5 text-red-400" data-id="element-548" data-mp="joy2ba3ad9c6" />
              <p className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-549" data-mp="okdezypk4z70">
                Cupos disponibles
              </p>
            </div>
            <div className="text-center mb-3" data-id="element-550" data-mp="evlqy1nmaz1d">
              <span className="text-5xl md:text-6xl font-black text-white tabular-nums" data-id="element-551" data-mp="euan61u69ra9">
                {spotsLeft}
              </span>
              <span className="text-2xl md:text-3xl font-bold text-red-200/50" data-id="element-552" data-mp="ygkw1nwm064">
                {' '}
                / {TOTAL_SPOTS}
              </span>
            </div>
            {/* Progress bar */}
            <div className="relative w-full h-3 bg-red-950 rounded-full overflow-hidden border border-red-700/60" data-id="element-553" data-mp="3s2dqvoy8hopw">
              <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-red-700 via-red-500 to-red-400 rounded-full transition-all duration-1000 ease-out shadow-[0_0_12px_rgba(239,68,68,0.8)]" style={{
              width: `${percentLeft}%`
            }} data-id="element-554" data-mp="1lbfnsrox7ci6" />
            </div>
            <p className="text-center text-xs text-red-200/80 mt-3 font-semibold" data-id="element-555" data-mp="35tzyicb3zhro">
              {spotsLeft <= 10 ? <span className="text-red-300 font-bold uppercase" data-id="element-556" data-mp="3kiw5e61fioqp">
                  ⚠️ ¡Quedan muy pocos! Asegurá el tuyo ya
                </span> : <>
                  Se están agotando rápido —{' '}
                  <span className="text-red-300 font-bold" data-id="element-557" data-mp="3tjaqb4ahe1to">
                    {TOTAL_SPOTS - spotsLeft} ya tomados
                  </span>
                </>}
            </p>
          </div>
        </div>

        {/* Bottom warning */}
        <div className="text-center mt-6" data-id="element-558" data-mp="7b1ds8lo1sl7">
          <p className="text-red-100/90 text-sm md:text-base" data-id="element-559" data-mp="7a00ryl3aw0u">
            🔒 Una vez que el contador llegue a 00:00,{' '}
            <span className="text-red-300 font-bold" data-id="element-560" data-mp="2937ej3l215km">
              esta oferta desaparece
            </span>{' '}
            y el precio sube a <span className="line-through" data-id="element-561" data-mp="245xr1th873zf">ARS 84.990</span>
          </p>
        </div>
      </div>
    </section>;
}